/**
 * Bor karaktere   * MINERAL - ásványos   * VELVETY - bársonyos   * RICH_LUSH - Dús/ buja   * SWEET - Édes   * WELL_GROOMED - Elegáns   * LIVELY - Élénk   * MILD - Enyhe   * SLIGHTLY_SWEET - Enyhén édes   * RIPE - Érett   * STRONG_INTENSE - Erős/ intenzív   * POWERFUL - Erőteljes   * EARTHY - Földes   * FRESH - friss   * REFRESHING - Frissítő   * SMOKY - füstös   * SPICY - fűszeres   * RICH - Gazdag   * FRUITY - gyümölcsös   * BARRIQUE - hordós (barrique)   * WHEEL - Kerek   * EXPRESSIVE - Kifejező   * SOPHISTICATED - Kifinomult   * CLASSIC - Klasszikus   * COMPLEX - komplex   * CONCENTRATED - Koncentrált   * LIGHT - Könnyű   * CREAMY - krémes   * SOFT - Lágy   * JUICY - Lédús   * AIRY - légies   * PERFUMED - parfümös   * ROBUST - Robusztus   * DRY - Száraz   * FULL - telt   * FULL_BODIED - testes   * FLORAL - virágos
 */
export type WineCharacter =
  | 'MINERAL'
  | 'VELVETY'
  | 'RICH_LUSH'
  | 'SWEET'
  | 'WELL_GROOMED'
  | 'LIVELY'
  | 'MILD'
  | 'SLIGHTLY_SWEET'
  | 'RIPE'
  | 'STRONG_INTENSE'
  | 'POWERFUL'
  | 'EARTHY'
  | 'FRESH'
  | 'REFRESHING'
  | 'SMOKY'
  | 'SPICY'
  | 'RICH'
  | 'FRUITY'
  | 'BARRIQUE'
  | 'WHEEL'
  | 'EXPRESSIVE'
  | 'SOPHISTICATED'
  | 'CLASSIC'
  | 'COMPLEX'
  | 'CONCENTRATED'
  | 'LIGHT'
  | 'CREAMY'
  | 'SOFT'
  | 'JUICY'
  | 'AIRY'
  | 'PERFUMED'
  | 'ROBUST'
  | 'DRY'
  | 'FULL'
  | 'FULL_BODIED'
  | 'FLORAL';

export const WineCharacter = {
  Mineral: 'MINERAL' as WineCharacter,
  Velvety: 'VELVETY' as WineCharacter,
  RichLush: 'RICH_LUSH' as WineCharacter,
  Sweet: 'SWEET' as WineCharacter,
  WellGroomed: 'WELL_GROOMED' as WineCharacter,
  Lively: 'LIVELY' as WineCharacter,
  Mild: 'MILD' as WineCharacter,
  SlightlySweet: 'SLIGHTLY_SWEET' as WineCharacter,
  Ripe: 'RIPE' as WineCharacter,
  StrongIntense: 'STRONG_INTENSE' as WineCharacter,
  Powerful: 'POWERFUL' as WineCharacter,
  Earthy: 'EARTHY' as WineCharacter,
  Fresh: 'FRESH' as WineCharacter,
  Refreshing: 'REFRESHING' as WineCharacter,
  Smoky: 'SMOKY' as WineCharacter,
  Spicy: 'SPICY' as WineCharacter,
  Rich: 'RICH' as WineCharacter,
  Fruity: 'FRUITY' as WineCharacter,
  Barrique: 'BARRIQUE' as WineCharacter,
  Wheel: 'WHEEL' as WineCharacter,
  Expressive: 'EXPRESSIVE' as WineCharacter,
  Sophisticated: 'SOPHISTICATED' as WineCharacter,
  Classic: 'CLASSIC' as WineCharacter,
  Complex: 'COMPLEX' as WineCharacter,
  Concentrated: 'CONCENTRATED' as WineCharacter,
  Light: 'LIGHT' as WineCharacter,
  Creamy: 'CREAMY' as WineCharacter,
  Soft: 'SOFT' as WineCharacter,
  Juicy: 'JUICY' as WineCharacter,
  Airy: 'AIRY' as WineCharacter,
  Perfumed: 'PERFUMED' as WineCharacter,
  Robust: 'ROBUST' as WineCharacter,
  Dry: 'DRY' as WineCharacter,
  Full: 'FULL' as WineCharacter,
  FullBodied: 'FULL_BODIED' as WineCharacter,
  Floral: 'FLORAL' as WineCharacter,
};
